import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=28f28cca&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28f28cca')) {
      api.createRecord('28f28cca', component.options)
    } else {
      api.reload('28f28cca', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=28f28cca&", function () {
      api.rerender('28f28cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4R6NQuLgCqTqJ/JS/cancellationPolicy.vue"
export default component.exports